import React, { useEffect, useState } from 'react';
import DataTable from 'react-data-table-component';
import { AxiosAdminInstance } from '../utils';
import { useParams } from 'react-router-dom';
import { DropDownComponent, InputComponent, CheckboxComponent, TextAreaComponent } from '../custcomponents';
const sortDates  = (rowA , rowB )  => {
  return  new Date(rowA.createdate).getTime() - new Date(rowB.createdate).getTime();
 };
// Define columns
const columns = [
  { name: 'Name', selector: row => row.name, sortable: true },
  { name: 'orderid', selector: row => row.orderid, sortable: true },
  { name: 'paytype', selector: row => row.paytype, sortable: true },
  { name: 'personalmailid', selector: row => row.personalmailid, sortable: true },
  { name: 'phonenumber', selector: row => row.phonenumber, sortable: true },
  { name: 'tickettype', selector: row => row.tickettype, sortable: true },
  { name: 'status', selector: row => row.status, sortable: true },
  { name: 'orderid', selector: row => row.orderdetails?.id, sortable: true },
  { name: 'payreponse', selector: row => row.payreponse?.id, sortable: true },
  { name: 'createdate', selector: row => row.createdate, sortable: true, sortFunction: sortDates  },
];
const ExpandedComponent = ({ data }) => (
  <div style={{ padding: '10px', backgroundColor: '#f9f9f9' }}>
    <strong>Complete JSON:</strong>
    <pre style={{ marginTop: '5px', fontSize: '13px', whiteSpace: 'pre-wrap' }}>
      {JSON.stringify(data, null, 2)}
    </pre>
  </div>
);
export  const ReportsTransaction = () => {
    const { eventcode } = useParams();
  const [data, setData] = useState([]);
  const [filterType, setFilterType] = useState('Individual');
  const [search, setSearch] = useState('');
  const [loading, setLoading] = useState(false);

  // Fetch data from server on dropdown change
  const fetchDataByType = async (type) => {
    setLoading(true);
    try {
        var apiurl = '/api/admin/gettransactionlist?eventcode=' + eventcode;
      
        const { data: response } = await AxiosAdminInstance.get(apiurl);
        console.log(response);
      setData(response.data);
    } catch (err) {
      console.error('Failed to fetch data:', err);
      setData([]);
    }
    setLoading(false);
  };

  useEffect(() => {
    const fetchData = async () => {
        setLoading(true);
        const { data: response } = await AxiosAdminInstance.get('/api/admin/gettransactionlist?eventcode=' + eventcode);
        console.log(response);
        if (response.result != "Success" || response.data?.length == 0) {
            setData([]);
            setLoading(false);
            return;
        }
        console.log(response.data);
        setData(response.data);
        setLoading(false);
    }
    fetchData();
}, []);
function convertArrayOfObjectsToCSV(array) {
	let result;

	const columnDelimiter = ',';
	const lineDelimiter = '\n';
	const keys = Object.keys(data[0]);

	result = '';
	result += keys.join(columnDelimiter);
	result += lineDelimiter;

	array.forEach(item => {
		let ctr = 0;
		keys.forEach(key => {
			if (ctr > 0) result += columnDelimiter;

			result += item[key];
			
			ctr++;
		});
		result += lineDelimiter;
	});

	return result;
}

// Blatant "inspiration" from https://codepen.io/Jacqueline34/pen/pyVoWr
function downloadCSV(e, array) {
	const link = document.createElement('a');
	let csv = convertArrayOfObjectsToCSV(array);
	if (csv == null) return;

	const filename = 'export.csv';

	if (!csv.match(/^data:text\/csv/i)) {
		csv = `data:text/csv;charset=utf-8,${csv}`;
	}

	link.setAttribute('href', encodeURI(csv));
	link.setAttribute('download', filename);
	link.click();
}

  // Local filter by search input (on already-fetched data)
  var filteredData = data;
  if(search && search != '')
  {
    filteredData= data.filter((item :  any) =>{
    return item.name.toLowerCase().includes(search.toLowerCase()) 
    || item.tickettype.toLowerCase().includes(search.toLowerCase()) 
    || item.phonenumber.toLowerCase().includes(search.toLowerCase()) 
    || item.personalmailid.toLowerCase().includes(search.toLowerCase());
}
  
  );
  }

  return (
    <section className="register-sec sec-padding-admin" data-scroll-index="8">
                <div className="container">
                    <div className="sec-title">
                        <span className="icon-inner wow flipInY" data-wow-duration="300ms"><span className="fa-stack"><i className="fa rhex fa-stack-2x"></i><i className="fa fa-user fa-stack-1x"></i></span></span>
                        <h3 className="wow fadeInRight" data-wow-duration="500ms">Transactions</h3>
                    </div> {/* <!--sec-title end--> */}
                    <div className="register-sec-details ">
                    <div className="row">
                                    <div className="col-lg-6 col-md-6 col-sm-6">
                                        <a href={"/weba/managereports/" + eventcode}>Registration Reports</a>
                                        </div>
                                        <div className="col-lg-6 col-md-6 col-sm-6">
                                        <a   href={"/weba/managegrppay/" + eventcode} >Group Pays Report</a>
                                        </div>
                                        </div>
                    <div className="row pt-2">
                                    <div className="col-lg-6 col-md-6 col-sm-6">
                                    

<InputComponent custname="couponCode" custid="txtcouponcode" custplaceholder="Filter"   onExternalValue={setSearch} onExternalBind={search} />
                                   


    
                                        
                                    </div>
                                    <div className="col-lg-6 col-md-6 col-sm-6">
                                    <div className="form-field text-center" data-wow-duration="300ms">
                                        <button type="button"  className="btn-default" onClick={(e) => downloadCSV(e, data)} >EXPORT  <i className="fa fa-arrow-circle-right"></i></button>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                <div className="col-lg-12 col-md-12 col-sm-12">
                                <DataTable
        columns={columns}
        data={filteredData}
        progressPending={loading}
        pagination
        highlightOnHover
        dense
        style={{ marginTop: '20px' }}
        expandableRows 
        expandableRowsComponent={ExpandedComponent}
      />
      </div>
                                    </div>
                    </div>
                    </div>
                    </section>

  );
};

export default ReportsTransaction;
